export default __webpack_public_path__ + "static/media/PlatformDuurzameHuisvesting-Logo.8b3e180c.png";